import React from "react";
import { Outlet } from "react-router-dom";
import StaffSidebar from "../../components/staff/StaffSidebar";
import { useTheme } from "../../context/ThemeContext";

function StaffLayout() {
  const { isDarkMode } = useTheme();
  
  return (
    <div className="d-flex">
      <StaffSidebar />
      <div className={`flex-grow-1 staff-content ${isDarkMode ? 'dark-dashboard' : ''}`}>
        <Outlet />
      </div>
    </div>
  );
}

export default StaffLayout;
